import { SelectProps } from 'antd'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { Select } from '@eastcoal/formily/components/Select'
import { ObjectField } from '@eastcoal/formily/exports/core'
import { useField } from '@eastcoal/formily/exports/react'

import { QuotaParamsTypeMap } from '@eastcoal/shared/enums/QuotaParamsType'

const options: SelectProps['options'] = mapNumberEnumOptions(QuotaParamsTypeMap)

export const QuotaTypeSelect = () => {
  const { value: parentValue, onInput } = useField<ObjectField>()

  const onChange = (value?: string) => {
    onInput({
      ...parentValue,
      type: value,
      value1: undefined,
      value2: undefined
    })
  }

  return (
    <Select
      options={options}
      style={{ width: 100 }}
      value={parentValue?.type}
      onChange={onChange as any}
    />
  )
}
